/**
 * 应用配置管理
 * 
 * 统一管理应用级别的配置，避免硬编码
 * 所有配置都从环境变量读取，便于维护和修改
 * 
 * @author 小华同学AI
 */

/**
 * 应用配置
 */
export const APP_CONFIG = {
  /** 应用标题 */
  APP_TITLE: import.meta.env.VITE_APP_TITLE || 'Contract.Pro',
  
  /** 应用 Logo URL（留空则使用默认文本 logo） */
  APP_LOGO_URL: import.meta.env.VITE_APP_LOGO_URL || '',

  /** 应用版权文案 */
  APP_COPYRIGHT: import.meta.env.VITE_APP_COPYRIGHT || '© 2025 Contract.Pro',
  
  /** 默认文本 Logo */
  DEFAULT_LOGO_TEXT: import.meta.env.VITE_APP_TITLE || 'Contract.Pro',
  
  /** 租户开关 */
  TENANT_ENABLE: import.meta.env.VITE_APP_TENANT_ENABLE === 'true',
  
  /** 验证码开关 */
  CAPTCHA_ENABLE: import.meta.env.VITE_APP_CAPTCHA_ENABLE === 'true',
  
  /** 租户ID */
  TENANT_ID: import.meta.env.VITE_TENANT_ID || '1',
} as const

/**
 * 检查是否配置了自定义 Logo
 */
export function hasCustomLogo(): boolean {
  return !!APP_CONFIG.APP_LOGO_URL && APP_CONFIG.APP_LOGO_URL.trim() !== ''
}

/**
 * 获取 Logo 配置
 */
export function getLogoConfig() {
  return {
    hasCustom: hasCustomLogo(),
    url: APP_CONFIG.APP_LOGO_URL,
    defaultText: APP_CONFIG.DEFAULT_LOGO_TEXT,
  }
}

/**
 * 获取版权文案
 */
export function getCopyrightText(): string {
  return APP_CONFIG.APP_COPYRIGHT
}

/**
 * 打印应用配置（用于调试）
 */
export function printAppConfig() {
  console.log('=== App Configuration ===')
  console.log('App Title:', APP_CONFIG.APP_TITLE)
  console.log('Logo URL:', APP_CONFIG.APP_LOGO_URL || '(使用默认文本 logo)')
  console.log('Copyright:', APP_CONFIG.APP_COPYRIGHT)
  console.log('Tenant Enable:', APP_CONFIG.TENANT_ENABLE)
  console.log('Captcha Enable:', APP_CONFIG.CAPTCHA_ENABLE)
  console.log('========================')
}
